import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import { FooterProps } from '../types';
import '../styles/RoadmapSlide.css';

export interface Milestone {
  id: string;
  title: string;
  weeks: string;
  color?: string;
  versionLabel?: string;
}

export interface RoadmapSlideProps {
  title: string;
  subtitle?: string;
  totalWeeks: number;
  milestones: Milestone[];
  footer?: FooterProps;
}

const RoadmapSlide: React.FC<RoadmapSlideProps> = ({
  title,
  subtitle,
  totalWeeks,
  milestones,
  footer
}) => {
  const weekNumbers = Array.from({ length: totalWeeks }, (_, i) => i + 1);

  const parseWeeks = (weeksStr: string): { start: number; end: number } => {
    const match = weeksStr.match(/(\d+)(?:-(\d+))?/);
    if (match) {
      const start = parseInt(match[1]);
      const end = match[2] ? parseInt(match[2]) : start;
      return { start, end };
    }
    return { start: 1, end: 1 };
  };

  return (
    <SlideLayout footer={footer} className="roadmap-slide">
      <div className="roadmap-content">
        <h1 className="roadmap-title">{title}</h1>
        {subtitle && <p className="roadmap-subtitle">{subtitle}</p>}

        <div className="roadmap-chart">
          {/* Header con números de semana */}
          <div className="roadmap-header">
            <div className="roadmap-label-cell"></div>
            {weekNumbers.map(week => (
              <div key={week} className="roadmap-week-cell">
                S{week}
              </div>
            ))}
            <div className="roadmap-version-header">Release</div>
          </div>

          {/* Milestones */}
          {milestones.map((milestone, index) => {
            const { start, end } = parseWeeks(milestone.weeks);
            const colors = ['#4318FF', '#7C3AED', '#2563EB', '#0891B2', '#059669'];
            const bgColor = milestone.color || colors[index % colors.length];

            return (
              <div key={milestone.id} className="roadmap-row">
                <div className="roadmap-label-cell">
                  <span className="milestone-badge" style={{ backgroundColor: bgColor }}>
                    {milestone.id}
                  </span>
                  <span className="milestone-title">{milestone.title}</span>
                </div>
                {weekNumbers.map(week => (
                  <div key={week} className="roadmap-cell">
                    {week >= start && week <= end && (
                      <div
                        className="roadmap-bar"
                        style={{ backgroundColor: bgColor }}
                      />
                    )}
                  </div>
                ))}
                <div className="roadmap-version-cell" style={{ backgroundColor: bgColor }}>
                  {milestone.versionLabel || ''}
                </div>
              </div>
            );
          })}
        </div>

        {/* Leyenda */}
        <div className="roadmap-legend">
          {milestones.map((milestone, index) => {
            const colors = ['#4318FF', '#7C3AED', '#2563EB', '#0891B2', '#059669'];
            const bgColor = milestone.color || colors[index % colors.length];
            return (
              <div key={milestone.id} className="legend-item">
                <span className="legend-color" style={{ backgroundColor: bgColor }} />
                <span className="legend-text">{milestone.id}: {milestone.title} ({milestone.weeks})</span>
              </div>
            );
          })}
        </div>
      </div>
    </SlideLayout>
  );
};

export default RoadmapSlide;
